import { Box } from "@mui/material";
import React from "react";
import styles from "./logDetailsComponent.module.scss";
import i18next from "i18next";
import LogGroupComponent from "./LogGroupComponent";
import _ from "lodash";
import PropTypes from "prop-types";

const LogDetailsComponent = (props) => {
  const { logData, start, setStart, type } = props;
  let count = 0;

  //Fix It during API Intergration based on API values
  const displayLogData = (n, LogData) => {
    return logData?.length === 0
      ? null
      : logData?.map((logItems) => {
          if (logItems.id <= n && count < start) {
            count = count + 1;

            return (
              <Box className={styles.group} key={logItems.id}>
                <LogGroupComponent
                  updatedFields={_.get(logItems, "updatedFields", [{}])}
                  updatedDate={logItems.updatedDate}
                />
              </Box>
            );
          }
          return null;
        });
  };
  const getDefaultData = (hasLogs) => {
    if (!hasLogs) {
      return (
        <Box className={styles.defaultTextWrapper}>
          {type === "dealer"
            ? "Nieuw bedrijf toegevoegd."
            : "Nieuw voertuig toegevoegd, geen update gevonden."}
        </Box>
      );
    } else if (logData.length <= start) {   
        return <Box></Box>;
    }
      else {
        return (
          <Box className={styles.showMoreWrapper}>
            <Box className={styles.showMoreBorder}>
              <Box className={styles.chevronicon}></Box>
            </Box>
            <Box
              className={styles.showMoreText}
              onClick={() => {
                setStart(start + 5);
              }}
            >
              {i18next.t("Show more logs")}
            </Box>
          </Box>
        );
      }
    
  };
  return (
    <Box className={styles.logDetailsWrapper} data-testid="LogDetailsComponent">
      <Box className={styles.logFrameGroup}>{displayLogData(25, logData)}</Box>

      {start < 25 ? (
        getDefaultData(logData?.length > 0)
      ) : (
        <Box className={styles.moreLogText}>
          {i18next.t("For more logs choose download")}{" "}
        </Box>
      )}
    </Box>
  );
};

export default LogDetailsComponent;

LogDetailsComponent.propTypes = {
  logData: PropTypes.any,
  start: PropTypes.any,
  setStart: PropTypes.any,
  type: PropTypes.any,
};
